import { AlertTypes, useAlertStore } from '@/store/alertsStore';

export default () => {
  const alertsStore = useAlertStore();

  function copyToClipboard(value: string, alert = true) {
    if (!alert) return navigator.clipboard.writeText(value);

    navigator.clipboard
      .writeText(value)
      .then(() => {
        alertsStore.addAlert({
          id: 'copy-to-clipboard-success',
          title: 'dict.copy',
          message: 'dict.copyToClipboard',
          dismissable: true,
          alertType: AlertTypes.Info,
          alertTimestamp: Date.now(),
          autoDismissDelay: 5000
        });
      })
      .catch(() => {
        alertsStore.addAlert({
          id: 'copy-to-clipboard-failed',
          title: 'dict.copy',
          message: 'dict.copyToClipboardFail',
          dismissable: true,
          alertType: AlertTypes.Error,
          alertTimestamp: Date.now(),
          autoDismissDelay: 5000
        });
      });
  }

  function bytesToHumanReadableString(bytes: number) {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    if (bytes === 0) return '0 Byte';

    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return Math.round((bytes / Math.pow(1024, i)) * 100) / 100 + ' ' + sizes[i];
  }

  function isMimeTypeAllowed(mime: string, allowedMime: string): boolean {
    const allowedMimeTypes = allowedMime.split(',');

    for (const allowedType of allowedMimeTypes) {
      if (mime === allowedType.trim()) {
        return true;
      }

      const mimeSplit = mime.split('/');
      const allowedMimeSplit = allowedType.trim().split('/');

      const matches = allowedMimeSplit.map((part, index) => {
        return part === '*' || part === mimeSplit[index];
      });

      if (matches.every((match) => match)) {
        return true;
      }
    }

    return false;
  }

  return {
    copyToClipboard,
    bytesToHumanReadableString,
    isMimeTypeAllowed
  };
};
